<template>
  <div>
    <!--    搜索部分-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="所属代理商" :label-width="formLabelWidth" prop="agent" style="margin-bottom: 17px">
        <el-input placeholder="请选择" v-model="enquiryForm.agent" size="medium" :disabled="true">
          <el-button slot="append" @click="mechanismSearch">选择</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
      <span style="color: red;font-weight: bold;margin-left: 10px">金牌配置实时生效,请勿随意操作!</span>
    </div>
    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'id', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">
      <el-table-column header-align="center" align="center" prop="id" label="ID" sortable></el-table-column>
      <el-table-column header-align="center" align="center" prop="user_name" label="用户姓名"></el-table-column>
      <el-table-column header-align="center" align="center" prop="rate" label="金牌额外费率"></el-table-column>
      <el-table-column header-align="center" align="center" prop="own_amount" label="上月交易量"></el-table-column>
      <el-table-column header-align="center" align="center" prop="team_amount" label="上月团队交易量"></el-table-column>
      <el-table-column header-align="center" align="center" prop="creator" label="创建者"></el-table-column>
      <el-table-column header-align="center" align="center" prop="create_time" label="创建时间"></el-table-column>
      <el-table-column header-align="center" align="center" prop="type" label="金牌类型">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type.value == '10'" type="success" disable-transitions>
            {{scope.row.type.text}}</el-tag>
          <el-tag v-if="scope.row.type.value == '20'" type="warning" disable-transitions>
            {{scope.row.type.text}}</el-tag>
          <el-tag v-if="scope.row.type.value == '30'" type="info" disable-transitions>
            {{scope.row.type.text}}</el-tag>
          <el-tag v-if="scope.row.type.value == '40'"  disable-transitions>
            {{scope.row.type.text}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope" style="text-align: center;">
          <el-button type="text" @click="thawInfo(scope.row)">设置比例</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
                   layout="total, sizes, prev, pager, next, jumper" style="text-align: right">
    </el-pagination>
    <!--      代理商选择表单部分-->
    <el-dialog v-if="mechanismVisible" title="配置表单" :visible.sync="mechanismVisible">
      <!--    搜索部分-->
      <el-form :inline="true" :model="dialogForm" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input
              size="medium"
              clearable
              v-model="dialogForm.user_name"
              placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
              size="medium"
              clearable
              v-model="dialogForm.mobile_phone"
              placeholder="请输入"></el-input>
        </el-form-item>
        <el-button
            size="medium"
            type="primary"
            style="font-size: 12px;"
            @click="handleSearch1(dialogForm)">搜索
        </el-button>
        <el-button
            size="medium"
            style="font-size: 12px;"
            @click="handleSearch2(dialogForm)">重置
        </el-button>
      </el-form>
      <!--    表格部分-->
      <el-table
          height="250"
          :data="dialogData"
          style="width: 100%"
          :default-sort="{prop: 'date', order: 'descending'}"
          v-loading="loading2"
          border
          @row-click="singleElection">
        <el-table-column align="center" width="55">
          <template slot="header">
            <span style="cursor:pointer" @click="cancelClick2">取消</span>
          </template>
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.row.id"
            >{{ '&nbsp;' }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="id"
            label="ID"
            sortable>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="user_name"
            label="代理商名称">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="mobile_phone"
            label="代理商手机号">
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <el-pagination
          background
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[20,50,100,200,500,1000]"
          :page-size="page_size1"
          :total="dialogTotal"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right"
      ></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog2">取 消</el-button>
        <el-button type="primary" @click="submitForm2">确 定</el-button>
      </div>
    </el-dialog>

    <!--    设置比例部分-->
    <el-drawer
        title="编辑"
        :visible.sync="dialog"
        direction="rtl"
        custom-class="demo-drawer"
        ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <el-form-item label="分润比例" :label-width="formLabelWidth" prop="rate"
                        style="margin-bottom: 17px">
            <el-input size="medium" v-model="form.rate"
                      placeholder="请输入分润比例" style="width: 300px">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="closeDrawer('ruleForm')">确定
          </el-button>
        </div>
      </div>
    </el-drawer>
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
  </div>
</template>

<script>
import {export_json_to_excel} from "@/excel/Export2Excel";
import prints from '@/components/print.vue';

export default {
  name: "goldConfiguration",//金牌配置页面
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      page_size: 20, //条数
      total: 0, //总数
      tableData: [], //表格数据
      enquiryForm: {
        page_size: 20,
        page: 1,
      },
      formLabelWidth: '80px',
      // 代理商表单部分
      loading2: true, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0,  //表单总数
      dialogData: [],//表单数据
      mechanismVisible: false,//代理商选择表单开启
      dialogCodeVisible: false,//邀请码表单页面显示
      dialogForm: {//表单搜索数据
        page_size: 20,
        mobile_phone: "",//手机号码
        page: 1,
        user_name: "",//用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      //下拨部分
      dialog: false,
      loading1: false,
      form: {
        rate: ''
      },
      rules: {
        rate: [
          {required: true, message: '请输入分润比例', trigger: 'blur'},
        ]
      },
      //打印
      tableTh: null,
      tableTd: null,
    }
  },
  created() {
    this.getData(this.enquiryForm);
    this.tableTh = ['ID', '用户姓名', '金牌额外费率', '上月交易量', '上月团队交易量', '创建者', '创建时间', '金牌类型'];
    this.tableTd = ['id', 'user_name', 'rate', 'own_amount', 'team_amount', 'creator', 'create_time', 'type_text'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    //设置比例
    thawInfo(row) {
      this.dialog = true;
      this.form.rate = row.rate;
      this.form.user_id = row.user_id;
    },
    //取消
    cancelForm() {
      this.dialog = false;
    },
    //设置比例确定
    closeDrawer(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 确定
          this.$api.post("/api/conf_center/goldSetRate", this.form, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              this.dialog = false;
              this.getData(this.enquiryForm)
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    //打印
    printEvent() {
      this.tableData.forEach(item => { //实名状态转换文本
        item.type_text = item.type.text;
      });
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },
    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.page = 1;
      searchForm.agent_id = '';
      searchForm.agent = '';
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/conf_center/goldConfList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 导出
    exportData() {
      let th = ['ID', '用户姓名', '金牌额外费率', '上月交易量', '上月团队交易量', '创建者', '创建时间', '金牌类型'];
      let excelData = ['id', 'user_name', 'rate', 'own_amount', 'team_amount', 'creator', 'create_time', 'type_text'];
      this.tableData.forEach(item => { //实名状态转换文本
        item.type_text = item.type.text;
      });
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 表单部分
// 代理商选择页面显示（表单显示）
    mechanismSearch() {
      this.mechanismVisible = true;
      this.getDialogData(this.dialogForm);
    },
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm);
    },
    //表单获取数据
    getDialogData(params) { //初始化数据
      this.loading2 = true;
      this.$api.post("/api/agent/getUserAgent?page=" + params.page, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading2 = false;
      })
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
    },
    //取消
    cancelClick2() {
      this.checkList = [];
      this.templateSelection = '';
    },
    // 表单确定
    submitForm2() {
      this.enquiryForm.agent = this.checkList.user_name;
      this.enquiryForm.agent_id = this.checkList.id;
      this.handleSearch2(this.dialogForm);
      this.cancelClick2();
      this.mechanismVisible = false;
      this.handleSearch(this.enquiryForm);
    },
    //表单取消
    cancelDialog2() {
      this.handleSearch2(this.dialogForm);
      this.cancelClick2();
      this.mechanismVisible = false;
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm);
    },
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

/deep/ .demo-drawer__footer {
  text-align: center;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}
</style>

